import { produce } from 'immer'
import createReducer from "./reducerUtils"

const initialState = {
    headerFilters: {},
    isExpanded: false
}

const header = {
    setHeaderFilters(state, action) {
        state.headerFilters = action.payload
    },
    updateHeaderFilters(state, action) {
        state.headerFilters = { ...state.headerFilters, ...action.payload }
    },
    setIsExpanded(state, action) {
        state.isExpanded = action.payload
    }
}

export default produce(
    (state, action) => createReducer(state, action, header),
    initialState
)

